import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import '../common/modals.css';
import '../common/dropdowns.css';
import './AdminView.css';
import AdminHeader from './AdminHeader.js';
import useAdminDirectory from './useAdminDirectory.js';
import useAdminClinics from './clinics/useAdminClinics.js';
import useAdminUsers from './users/useAdminUsers.js';
import useAdminTeams from './teams/useAdminTeams.js';
import useAdminRoles from './roles/useAdminRoles.js';

const AdminView = ({
  variant = 'clinic',
  isSidebarExpanded = false,
  title,
  documentTitle,
  titleAccessory = null,
  showViewerSubtitle = false,
  fetchClinics,
  fetchClinicUsers,
  fetchTeams,
}) => {
  const directory = useAdminDirectory({ variant, fetchClinics, fetchClinicUsers, fetchTeams });
  const clinics = useAdminClinics(directory);
  const users = useAdminUsers(directory);
  const teams = useAdminTeams(directory);
  const roles = useAdminRoles(directory);

  useEffect(() => {
    if (documentTitle) {
      document.title = documentTitle;
    }
  }, [documentTitle]);

  const isLoading = directory.isMaster
    ? directory.loading.clinic || directory.loading.roles
    : directory.loading.users || directory.loading.clinic || directory.loading.teams;

  return (
    <div className={`admin-view${isSidebarExpanded ? ' sidebar-expanded' : ''}`}>
      <AdminHeader
        title={title}
        titleAccessory={titleAccessory}
        showViewerSubtitle={showViewerSubtitle}
        actions={(
          <>
            {users.headerActions}
            {teams.headerActions}
            {roles.headerActions}
          </>
        )}
      />

      <div className="admin-content">
        {isLoading ? (
          <div className="admin-loading">
            <FontAwesomeIcon icon={faSpinner} spin size="3x" />
            <p>Loading data...</p>
          </div>
        ) : (
          <div className="admin-tables-container">
            {clinics.section}
            {users.section}
            {teams.section}
            {roles.section}
          </div>
        )}
      </div>

      {users.modals}
      {teams.modals}
      {roles.modals}
    </div>
  );
};

export default AdminView;
